// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PatientProfilePage_page-container__H66A\\+ {
  padding: 0;
}

.PatientProfilePage_error-message__2lK3f {
  text-align: center;
  font-size: 1.2rem;
  color: #e53e3e;
  margin-top: 3rem;
  padding: 2rem;
  background-color: #fff5f5;
  border: 1px solid #f56565;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/PatientProfilePage/PatientProfilePage.module.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AACJ","sourcesContent":[".page-container {\n    padding: 0;\n}\n\n.error-message {\n    text-align: center;\n    font-size: 1.2rem;\n    color: #e53e3e;\n    margin-top: 3rem;\n    padding: 2rem;\n    background-color: #fff5f5;\n    border: 1px solid #f56565;\n    border-radius: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page-container": `PatientProfilePage_page-container__H66A+`,
	"error-message": `PatientProfilePage_error-message__2lK3f`
};
export default ___CSS_LOADER_EXPORT___;
